export const SP_WIDTH = 768;
